<template>
  <div id="auth-card" class="card-box-welcome login-card" :class="{ 'login-card__centered': !isFillDataCard }">
    <div v-if="isFillDataCard" class="back_button max-h-700-mobile">
      <i class="demo-icon icon-back" @click="$eventHub.$emit('AuthGoBack')"></i>
    </div>
    <div>
      <!--      <div class="progress w-100" v-if="isFillDataCard">-->
      <!--        <div class="progress-bar" role="progressbar" :style="'width: ' + progress + '%'" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></div>-->
      <!--      </div>-->

      <Step v-if="isFillDataCard" :step="step" class="my-2"></Step>

      <keep-alive>
        <div
          :is="currentComponent"
          :profile="profile"
          :swap-component="swapComponent"
          :form="form"
          :progress="progress"
          @reset-form="resetForm"
          @update:progress="progress = $event"
          @update:step="step = $event"
        ></div>
      </keep-alive>
    </div>
    <img src="/img/spinner.gif" class="loader" alt="" style="opacity: 0.1" />
  </div>
</template>
<script>
import WelcomeCard from './WelcomeCard.vue';
import RegisterEmailCard from './RegisterEmailCard.vue';
import NameEmailLastCard from './NameEmailLastCard.vue';
import RegisterPhoneCard from './RegisterPhoneCard.vue';
import VerificationEmailCard from './VerificationEmailCard.vue';
import VerificationPhoneCard from './VerificationPhoneCard.vue';
import LoginCard from './LoginCard.vue';
import NameCard from './NameCard.vue';
import GenderCard from './GenderCard.vue';
import BirthdayCard from './BirthdayCard.vue';
import LocationCard from './LocationCard.vue';
import RegistrationSuccessCard from './RegistrationSuccessCard';
import ResetPasswordCard from './ResetPasswordCard';
import ResetPasswordEmailCard from './ResetPasswordEmailCard';
import ResetPasswordPhoneCodeCard from './ResetPasswordPhoneCodeCard';
import ResetPasswordPhoneCard from './ResetPasswordPhoneCard';
import PreferencesCard from './PreferencesCard.vue';
import Step from './Step.vue';

export default {
  props: {
    cardComponent: {
      type: String,
      default: 'auth-welcome-card',
    },
    email: {
      type: String,
      default: null,
    },
    cid: {
      type: String,
      default: null,
    },
    profile: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    currentComponent: '',
    form: {
      id: null,
      name: null,
      gender: null,
      preferred_gender: [],
      birth_date: null,
      location_id: null,
      // phone: null,
      //    token: '',
      preferences: [],
      email: null,
      search: {
        age_from: 18,
        age_to: 30,
      },
      auth_step: '',
      isLoggedId: false,
      termsAndAge: false,
    },
    progress: 0,
    step: 1,
  }),
  components: {
    'auth-welcome-card': WelcomeCard,
    'auth-register-email-card': RegisterEmailCard,
    'auth-name-email-last-card': NameEmailLastCard,
    'auth-register-phone-card': RegisterPhoneCard,
    'auth-verification-phone-card': VerificationPhoneCard,
    'auth-verification-email-card': VerificationEmailCard,
    'auth-login-card': LoginCard,
    'auth-name-card': NameCard,
    'auth-preferences-card': PreferencesCard,
    'auth-gender-card': GenderCard,
    'auth-birthday-card': BirthdayCard,
    'auth-location-card': LocationCard,
    'auth-registration-success-card': RegistrationSuccessCard,
    'auth-reset-password-card': ResetPasswordCard,
    'auth-reset-password-email-card': ResetPasswordEmailCard,
    'auth-reset-password-phone-code-card': ResetPasswordPhoneCodeCard,
    'auth-reset-password-phone-card': ResetPasswordPhoneCard,
    Step,
  },
  computed: {
    isFillDataCard: function () {
      const fillDataCards = [
        'auth-name-card',
        'auth-gender-card',
        'auth-birthday-card',
        'auth-location-card',
        'auth-preferences-card',
        'auth-name-email-last-card',
      ];
      return fillDataCards.includes(this.currentComponent);
    },
  },
  watch: {
    currentComponent: function (value) {
      let homepage = document.getElementById('homepage');
      if (homepage && value === 'auth-welcome-card') {
        homepage.classList.add('vue-welcome-card');
      } else if (homepage) {
        homepage.classList.remove('vue-welcome-card');
      }
    },
  },
  methods: {
    resetForm() {
      this.form.id = null;
      this.form.name = null;
      this.form.gender = null;
      this.form.preferred_gender = [];
      this.form.birth_date = null;
      this.form.location_id = null;
      this.form.phone = null;
      this.form.email = null;
      this.form.search = {
        age_from: 18,
        age_to: 30,
      };
      this.form.isLoggedId = false;
    },
    swapComponent: function (component) {
      this.currentComponent = component;
    },
    initialComponent() {
      const vm = this;
      axios
        .get(zRoute('ajax.auth.users.show'))
        .then(function (response) {
          if (response.status !== 204) {
            vm.form = response.data.data;
            vm.form.isLoggedId = true;

            switch (vm.form.auth_step) {
              case 'email':
                vm.currentComponent = 'auth-verification-email-card';
                break;
              case 'phone':
                vm.currentComponent = 'auth-verification-phone-card';
                break;
              case 'name':
                vm.currentComponent = 'auth-name-email-last-card';
                break;
              case 'preferences':
                vm.currentComponent = 'auth-preferences-card';
                break;
              case 'gender':
                vm.currentComponent = 'auth-gender-card';
                break;
              case 'birthday':
                vm.currentComponent = 'auth-birthday-card';
                break;
              case 'location':
                vm.currentComponent = 'auth-location-card';
                break;
              default:
                vm.currentComponent = vm.form.filled ? vm.cardComponent : 'auth-birthday-card';
            }
          } else {
            vm.currentComponent = vm.cardComponent;
          }
        }, function (error) {
          vm.currentComponent = vm.cardComponent;
        });
    },
  },
  created() {
    if (this.email !== null && this.email !== '') {
      this.form.email = this.email;
      this.currentComponent = 'auth-register-email-card';
    } else {
      this.initialComponent();
    }

    if (this.cid) {
      window.localStorage.setItem('campaign_cid', this.cid);
    }
  },
};
</script>
<style scoped></style>
